export var SERVER_LIST_PATH = '/servers/';
export var SERVER_PATH = '/servers/:serverIdentifier/';
